import { InAppMessageIdentifierChecker } from "../evaluation/InAppMessageIdentifierChecker"
import { resolveIdentifiers, User } from "../../../core/internal/model/model"
import Logger from "../../../core/internal/logger"
import { InAppMessageDelayManager } from "../delay/InAppMessageDelayManager"

export class InAppMessageResetProcessor {
  constructor(
    private readonly identifierChecker: InAppMessageIdentifierChecker,
    private readonly delayManager: InAppMessageDelayManager
  ) {}

  process(oldUser: User, newUser: User) {
    try {
      const isIdentifierChanged = this.identifierChecker.isIdentifierChanged(
        resolveIdentifiers(oldUser),
        resolveIdentifiers(newUser)
      )
      if (isIdentifierChanged) {
        this.delayManager.cancelAll()
      }
    } catch (e) {
      Logger.log.error(`Failed to reset InAppMessage: ${e}`)
    }
  }
}
